<template>
    <section class="section estadisticaView">
        <h1 class="title is-4 has-text-centered is-hidden-desktop"><font-awesome-icon icon="chart-bar"/> Estadistica</h1>
        <div class="columns">
            <div class="column is-3">
                <Panel title="10 equipos mas populares">
                    <div class="panel-block is-block" v-for="equipo in estadistica.equipos" :key="equipo.id">
                        <div class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">{{equipo.nombre}}</div>
                            </div>
                            <div class="level-right">
                                <div class="level-item"><span class="tag">{{equipo.user_count}}</span></div>
                            </div>
                        </div>
                    </div>
                </Panel>
            </div>

            <div class="column is-9">
                <div class="columns is-multiline">
                    <div class="column is-4" v-for="top10 in estadistica.top10" :key="top10.torneo.nombre">
                        <article class="panel is-relative">
                            <div class="panel-heading">
                                <div class="level is-mobile">
                                    <div class="level-left">
                                        <div class="level-item">
                                            Top 5 aciertos
                                        </div>
                                    </div>
                                    <div class="level-right">
                                        <div class="level-item">
                                            <figure class="image is-32x32"><img :title="top10.torneo.nombre" :src="top10.torneo.logo"/></figure>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <router-link :to="'perfil/' + jugador.id" class="panel-block is-block" v-for="jugador in top10.jugadores.slice(0,5)" :key="jugador.id">
                                <div class="level is-mobile">
                                    <div class="level-left">
                                        <div class="level-item jugadorTop">{{ jugador.name }}</div>
                                    </div>
                                    <div class="level-right">
                                        <div class="level-item">
                                            <span class="tag">{{ jugador.predicciones_count }}</span>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </article>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import Panel from '@/components/Panel'
    import { mapState } from 'vuex'
    export default {
        components: { Panel },
        name: 'Estadistica',
        created(){
            this.$store.dispatch('estadistica/fetchEstadistica')
        },
        computed: {
            ...mapState('estadistica',['estadistica'])
        },
        metaInfo(){
			return {
				title: 'Estadística | Quinielazo.com',
				meta: [
					{
						name: 'description',
						content: 'Los mejores jugadores y sus posiciones en quinielazo.com, equipos mas populares, Top 5 de aciertos en Liga MX, Premiership Inglaterra, Liga BBVA, Champions League'
					}
				]
			}
        },
        mounted() {
            window.scrollTo(0,0)
        },
    }
</script>

<style scoped>
.estadisticaView{
    padding: 1rem 1rem;
}
.jugadorTop{
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline;
}
.level-left{
    flex-shrink: 1;
    overflow: hidden;
}
@media screen and (max-width: 769px){
    .jugadorTop{
        white-space: normal;
    }
}
</style>